module.exports = __webpack_public_path__ + "static/img/1.1d615260.png";